"use client";

import { useSyncExternalStore } from "react";

import { shouldUseMockData } from "./utils";

// Literal matches DEMO_MODE_CHANGE_EVENT in ./utils — kept local so tests
// that mock `@/lib/mock-data/utils` without that export still subscribe.
const DEMO_MODE_CHANGE_EVENT = "sv-demo-mode-change";

function subscribeDemoMode(onStoreChange: () => void): () => void {
  if (typeof window === "undefined") return () => undefined;
  const handleStorage = (event: StorageEvent) => {
    if (event.key === "sigmavue_demo_mode") onStoreChange();
  };
  window.addEventListener(DEMO_MODE_CHANGE_EVENT, onStoreChange);
  window.addEventListener("storage", handleStorage);
  return () => {
    window.removeEventListener(DEMO_MODE_CHANGE_EVENT, onStoreChange);
    window.removeEventListener("storage", handleStorage);
  };
}

/**
 * Hydration-safe demo/mock gate. Server + first client paint are always
 * `false`; localhost demo mode flips on after hydration (and on the
 * same-tab DEMO_MODE_CHANGE_EVENT / cross-tab `storage` write).
 */
export function useShouldUseMockData(): boolean {
  return useSyncExternalStore(subscribeDemoMode, shouldUseMockData, () => false);
}
